import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Product'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({
    getAllProduct: builder.query({
      query: (data) => ({
        url: `books?page=${data.page}&size=${data.size}&searchid=${data.searchid}&category_id=${data.id ? data.id : ''}`,
        method: 'GET',
        headers: {
          'X-User-Token': localStorage.getItem('userToken'),
          'X-User-Id': localStorage.getItem('userId'),
          'X-User-Role': localStorage.getItem('userRole'),
          'X-Language': data.languageCode,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      // keepUnusedDataFor: 1,
      providesTags: ['Product'],
    }),
    createBook: builder.mutation({
      query: (data) => {
        return {
          url: `books`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),
    updateBook: builder.mutation({
      query: (data) => {
        return {
          url: `books/${data.update_id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),
    disableBook: builder.mutation({
      query: (id) => {
        return {
          url: `books`,
          method: 'PUT',
          body: id,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),

    deleteBook: builder.mutation({
      query: (data) => {
        return {
          url: `books/${data.delete_id}`,
          method: 'DELETE',
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),

 

    getProductById: builder.query({
      query: (data) => {
        return {
          url: `books/${data.id}?book_details=${data.book_details}`,
          method: 'GET',
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Product'],
    }),

    getSummaryById: builder.query({
      query: (data) => {
        return {
          url: `summaries/${data.id}`,
          method: 'GET',
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Product'],
    }),

    

    createProduct: builder.mutation({
      query: (data) => {
        
        return {
          url: `books`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),

    createSummary: builder.mutation({
      query: (newPost) => {
        return {
          url: `summaries`,
          method: 'POST',
          body: newPost,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),

    updateSummary: builder.mutation({
      query: (newPost) => ({
        url: `summaries`,
        method: 'PUT',
        body: newPost,
        headers: {
          'X-User-Token': localStorage.getItem('userToken'),
          'X-User-Id': localStorage.getItem('userId'),
          'X-User-Role': localStorage.getItem('userRole'),
          'X-Language': data.languageCode,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),

    updateImage: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append("myFile", data.image_file);
        return {
          url: `summaries`,
          method: 'POST',
          body: formData,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'X-Book-Id': data.book_id,
            'X-Token-Id': data.token,
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),

    updateAudio: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append("myFile", data.audio_file);
        return {
          url: `summaries`,
          method: 'PUT',
          body: formData,
          headers: {
            'X-User-Token': localStorage.getItem('userToken'),
            'X-User-Id': localStorage.getItem('userId'),
            'X-User-Role': localStorage.getItem('userRole'),
            'X-Language': data.languageCode,
            'X-Book-Id': data.book_id,
            'X-Summary-Id': data.summary_id,
            'X-Token-Id': data.token,
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),




    

    getCategoryBooks: builder.query({
      query: (data) => ({
        url: `books/${data.id}?page=${data.page}&size=${data.size}&searchid=${data.searchid}&category_books=${data.category_books}`,
        method: 'GET',
        headers: {
          'X-User-Token': localStorage.getItem('userToken'),
          'X-User-Id': localStorage.getItem('userId'),
          'X-User-Role': localStorage.getItem('userRole'),
          'X-Language': data.languageCode,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Product'],
    }),



  }),
})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useGetAllProductQuery, useDisableBookMutation, useGetProductByIdQuery, useGetSummaryByIdQuery, useCreateProductMutation, useCreateSummaryMutation, useUpdateSummaryMutation, useCreateBookMutation, useUpdateBookMutation, useDeleteBookMutation, useUpdateImageMutation, useGetCategoryBooksQuery, useUpdateAudioMutation, useDeleteSummaryMutation } = productsApi